// sliders
$('.product-offer__main-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  infinite: true,
  asNavFor: '.product-offer__nav-slider',
});
$('.product-offer__nav-slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.product-offer__main-slider',
  dots: false,
  focusOnSelect: true,
  infinite: true,
  arrows: true,
  prevArrow: $('.product-offer__button-carousel.btn-prev'),
  nextArrow: $('.product-offer__button-carousel.btn-next'),
});

// product offer
document.addEventListener('DOMContentLoaded', () => {
  const variantItems = document.querySelectorAll('.product-offer__variant-item');
  const variantInput = document.getElementById('selected-variant-id');
  const buyNowBtn = document.getElementById('buy-now');
  const form = buyNowBtn.closest('form');
  const subscriptionWrapper = document.getElementById('subscription-wrapper');
  const checklistWrapper = document.querySelector('.product-offer__info-checklist');
  const checklistItems = checklistWrapper
    ? checklistWrapper.querySelectorAll('.product-offer__checklist-item .value')
    : [];
  const buyOnceBtn = document.getElementById('product-offer__buy-once-btn');

  const subscriptionCheckbox = document.getElementById('offer-subscription');

  const btnPrice = buyNowBtn.querySelector('.btn-price');
  const btnCompare = buyNowBtn.querySelector('.btn-compare');

  form.addEventListener('submit', e => e.preventDefault());

  function updatePrices() {
    const selected = document.querySelector('.product-offer__variant-item.selected');
    if (!selected) return;

    const sellingPlanId = selected.dataset.sellingPlanId;
    const hasSellingPlan = !!sellingPlanId;

    if (!hasSellingPlan) {
      subscriptionCheckbox.checked = false;
      subscriptionWrapper.classList.add('hidden-display');
    } else {
      subscriptionWrapper.classList.remove('hidden-display');
    }

    const isSub = subscriptionCheckbox.checked && hasSellingPlan;

    variantItems.forEach(item => {
      const priceEl = item.querySelector('.price');
      const compareEl = item.querySelector('.compare-price');
      const savingEl = item.querySelector('.product-offer__variant-saving');

      const price = isSub
        ? item.dataset.subscriptionPrice
        : item.dataset.price;

      const savings = isSub
        ? item.dataset.savingsSub
        : item.dataset.savings;

      if (priceEl) priceEl.textContent = price;
      if (savingEl && savings) { savingEl.textContent = savings; }
      if (compareEl) compareEl.textContent = item.dataset.comparePrice;
    });

    const activePrice = isSub
      ? selected.dataset.subscriptionPrice
      : selected.dataset.price;

    btnPrice.textContent = activePrice;

    if (selected.dataset.comparePrice) {
      btnCompare.textContent = selected.dataset.comparePrice;
      btnCompare.style.display = 'inline';
    } else {
      btnCompare.style.display = 'none';
    }
  }

  function updateChecklist() {
    if (!checklistItems.length) return;

    const selected = document.querySelector('.product-offer__variant-item.selected');
    if (!selected) return;

    const selectedIndex = Array.from(variantItems).indexOf(selected);

    checklistItems.forEach(item => {
      const rawText = item.dataset.originalValue || item.textContent.trim();

      if (!item.dataset.originalValue) {
        item.dataset.originalValue = rawText;
      }

      const parts = rawText.split('|').map(p => p.trim());

      if (parts.length === 1) {
        item.textContent = parts[0];
        item.closest('.product-offer__checklist-item').style.display = '';
        return;
      }

      if (parts[selectedIndex]) {
        item.textContent = parts[selectedIndex];
        item.closest('.product-offer__checklist-item').style.display = '';
      } else {
        item.closest('.product-offer__checklist-item').style.display = 'none';
      }
    });
  }

  // variant select
  variantItems.forEach(item => {
    item.addEventListener('click', () => {
      variantItems.forEach(v => v.classList.remove('selected'));
      item.classList.add('selected');
      variantInput.value = item.dataset.id;
      updatePrices();
      updateChecklist();
    });
  });

  subscriptionCheckbox.addEventListener('change', updatePrices);

  buyNowBtn.addEventListener('click', async e => {
    e.preventDefault();

    const variantId = variantInput.value;
    if (!variantId) return;

    const selected = document.querySelector('.product-offer__variant-item.selected');
    const sellingPlanId = selected?.dataset.sellingPlanId;
    const hasSellingPlan = !!sellingPlanId;
    const isSub = subscriptionCheckbox.checked && hasSellingPlan;

    buyNowBtn.classList.add('loading');
    buyNowBtn.setAttribute('disabled', true);

    try {
      await fetch('/cart/clear.js', { method: 'POST' });

      const payload = {
        id: variantId,
        quantity: 1
      };

      if (isSub) {
        payload.selling_plan = sellingPlanId;
      }

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      window.location.href = '/checkout';

    } catch (err) {
      console.error(err);

      buyNowBtn.classList.remove('loading');
      buyNowBtn.removeAttribute('disabled');
    }
  });

  if (buyOnceBtn) {
    buyOnceBtn.addEventListener('click', async e => {
      e.preventDefault();

      const variantId = variantInput.value;
      if (!variantId) return;

      buyOnceBtn.classList.add('loading');
      buyOnceBtn.setAttribute('disabled', true);

      try {
        await fetch('/cart/clear.js', { method: 'POST' });

        const payload = {
          id: variantId,
          quantity: 1
        };

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        window.location.href = '/checkout';

      } catch (err) {
        console.error(err);

        buyOnceBtn.classList.remove('loading');
        buyOnceBtn.removeAttribute('disabled');
      }
    });
  }

  updatePrices();
  updateChecklist();
});

window.addEventListener('pageshow', () => {
  const buyNowBtn = document.getElementById('buy-now');
  const buyOnceBtn = document.getElementById('product-offer__buy-once-btn');

  [buyNowBtn, buyOnceBtn].forEach(btn => {
    if (!btn) return;
    btn.classList.remove('loading');
    btn.disabled = false;
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // stock message/date
  const stockMsg = document.querySelector('.product-offer__stock-message');
  if (!stockMsg) return;

  const daysToAdd = parseInt(stockMsg.getAttribute('data-days'), 10);

  const today = new Date();
  const futureDate = new Date(today);
  futureDate.setDate(today.getDate() + daysToAdd);

  function getOrdinal(n) {
    if (n > 3 && n < 21) return n + 'th';
    switch (n % 10) {
      case 1: return n + 'st';
      case 2: return n + 'nd';
      case 3: return n + 'rd';
      default: return n + 'th';
    }
  }
  const month = futureDate.toLocaleString('en-US', { month: 'long' });
  const dayWithSuffix = getOrdinal(futureDate.getDate());
  const innerSpan = stockMsg.querySelector('span');
  innerSpan.innerHTML += ` <span class="date">${month} ${dayWithSuffix}</span>`;
});

// sticky button
document.addEventListener("DOMContentLoaded", function () {
  const stickyDiv = document.querySelector('.product-offer__sticky');
  const stickyBtn = stickyDiv.querySelector('.product-offer__sticky-btn');
  const wrapper = document.querySelector('.product-offer__wrapper');
  const footer = document.querySelector('.site-footer');

  function handleScroll() {
    const wrapperRect = wrapper.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();
    const stickyRect = stickyDiv.getBoundingClientRect();

    const hasPassedWrapper = wrapperRect.bottom <= 0;
    const footerIsTouching = stickyRect.bottom >= footerRect.top;

    if (hasPassedWrapper && !footerIsTouching) {
      stickyDiv.classList.add('visible');
    } else {
      stickyDiv.classList.remove('visible');
    }
  }

  window.addEventListener('scroll', handleScroll);

  stickyBtn.addEventListener('click', function (e) {
    e.preventDefault();

    const link = this.dataset.link;

    if (link && link.trim() !== '') {
      window.location.href = link;
      return;
    }

    const target = document.querySelector('#product-offer');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });

  handleScroll();
});
